import { useMutation } from '@tanstack/react-query';
import { getCheck } from '../api/service.api';

export const useGetCheck = () => {
    return useMutation({
        mutationFn: (fiscalId: string) => getCheck(fiscalId),
    });
};
